import { render, staticRenderFns } from "./Stage1.vue?vue&type=template&id=09ed3d28&scoped=true&"
import script from "./Stage1.vue?vue&type=script&lang=js&"
export * from "./Stage1.vue?vue&type=script&lang=js&"
import style0 from "./Stage1.vue?vue&type=style&index=0&id=09ed3d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ed3d28",
  null
  
)

export default component.exports